import React from 'react';
import Row from '../../../../core/layout/Row';
import Column from '../../../../core/layout/Column';
import ContentMasteryTestFailureAttemptRateGaugeContainer from './mastery-test/ContentMasteryTestFailureAttemptRateGaugeContainer';
import ContentMasteryTestRepeatRateGaugeContainer from './mastery-test/ContentMasteryTestRepeatRateGaugeContainer';
import ContentMasteryTestSpeechRateGaugeContainer from './mastery-test/ContentMasteryTestSpeechRateGaugeContainer';
import ContentMasteryTestErrorRateGaugeContainer from './mastery-test/ContentMasteryTestErrorRateGaugeContainer';

const ContentMasteryTestChartScene = () => (
  <div>
    <Row>
      <Column size={3}>
        <ContentMasteryTestFailureAttemptRateGaugeContainer />
      </Column>
      <Column size={3}>
        <ContentMasteryTestRepeatRateGaugeContainer />
      </Column>
      <Column size={3}>
        <ContentMasteryTestSpeechRateGaugeContainer />
      </Column>
      <Column size={3}>
        <ContentMasteryTestErrorRateGaugeContainer />
      </Column>
    </Row>
  </div>
);

export default ContentMasteryTestChartScene;
